export default __webpack_public_path__ + "static/media/lato-bold.f880567c.eot";